<template>
    <div class="page wallet">
        <div class="title">
            <mu-appbar title="我的银行卡" class="center">
                <router-link slot="left" to="/home/wallet">
                    <mu-icon value="keyboard_arrow_left" color="white" />
                </router-link>
                <span class="topT left"> </span>
            </mu-appbar>
        </div>
        <div :class="[cardClass(card.bankName),'card']" v-for="(card,index) in cards">
            <div class="top">
                <div class="left">
                    <mu-avatar :src="'../../../static/wallet/banks/'+cardClass(card.bankName)+'.png'" />
                    <div>{{card.bankName}}<br/>
                        <small>{{card.cardType}}</small>
                    </div>
                </div>
                <div class="right">
                    <a href="#" @click="unbundling(index)">解绑</a>
                </div>
            </div>
            <div class="bankcardBt">
                {{card.replaceBankCard}}
            </div>
        </div>
        <div class="add">
          <router-link class="right" to="/wallet/addBankCard">
            <mu-icon value="add" :size="22" />&nbsp;添加银联信用卡
          </router-link>
        </div>
        <mu-dialog :open="dialog" @close="close">
            <div style="color:black;">
                尊敬的客户，您确认要删除这个银行卡信息？
            </div>
            <div style="padding:10px 0px;margin-top:10px;">
                <mu-raised-button @click="close" label="取消" class="demo-raised-button" style="float:left;" />
                <mu-raised-button @click="check" primary label="确定" class="demo-raised-button" style="float:right;" />
            </div>
        </mu-dialog>
        <mu-toast v-if="toast" :message="TellUser" @close="hideToast" id="alertline" />
    </div>
</template>

<style lang="less" scoped>
// @import "../../assets/theme.less";
.page {
    background: rgba(0, 0, 0, 0.8);
    .title {
        .mu-appbar {
            background: rgba(0, 0, 0, 0.1);
        }
    }
    .card {
        width: 94%;
        margin: 3%;
        border-radius: 5px;
        color: white;
        .top {
            width: 100%;
            margin: 0;
            height: 100px;
            display: flex;
            display: -webkit-flex;
            padding: 25px 0px 25px 5%;
            .left {
                width: 70%;
                font-size: 0.32rempx;
                .mu-avatar {
                    display: inline-block;
                    margin-right: 20px;
                    width: 0.95rem;
                }
                div {
                    float: left;
                }
                small {
                    font-size: 0.26rem;
                }
            }
            .right {
                font-size: 0.26rem;
                width: 25%;
                position: relative;
                text-align: right;
                a {
                    color: white;
                }
            }
            position:relative;
        }
        .top::before {
            content: '';
            background: hsla(0, 0%, 100%, .2);
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
        }
        .bankcardBt {
            width: 100%;
            text-align: center;
            font-size: 0.44rem;
            margin: auto;
            padding: 5px;
        }
    }
    .add {
        a {
            color: #666666;
            font-size: 0.28rem;
        }
        background-color:hsla(0, 0%, 50%, .1);
        text-align:center;
        padding:10px;
        .mu-icon {
            position: relative;
            top: 6px;
        }
    }
    .pinan {
        background-color: #FF5C33;
    }
    .jianshe {
        background-color: #1C63B0;
    }
    .guangfa {
        background-color: #920900;
    }
    .jiaotong {
        background-color: #051d59;
    }
    .pufa {
        background-color: #013475;
    }
    .xingye {
        background-color: #103885;
    }
    .zhaoshang {
        background-color: #b2082c;
    }
    .gongshang {
        background-color: #cb050d;
    }
    .guangda {
        background-color: #d2ac2d;
    }
    .mingsheng {
        background-color: #08975a;
    }
    .nongye {
        background-color: #158b75;
    }
    .zhongguo {
        background-color: #a2011f;
    }
    .youzheng {
        background-color: #219734;
    }
    .zhongxin {
        background-color: #c20f10;
    }
    .huaxia {
        background-color: #b2082c;
    }
}
</style>

<script>
import api from '../../api'
import bank from '../../utils/bankCard'
export default {
    data() {
        return {
            toast: false,
            dialog: false,
            cards: [],
            current: '',
            TellUser:'',
        }
    },
    created() {
        this.getCards();
    },
    activated() {
        this.getCards();
    },
    methods: {
        cardClass(name) {
            return bank.cardClass(name);
        },
        unbundling(index) {
            var e = window.event || arguments[0];
            e.preventDefault();
            this.current = index;
            this.open();
        },
        check() {
            this.close();
            var params = new this.URLSearchParam();
            params.append('bankCard', this.cards[this.current].bankCard);
            this.$http.post(api.cancelBindCard(), params.toParam()).then((res) => {
                if (res.Result) {
                    this.TellUser = res.Data;
                    this.cards.splice(this.current, 1);
                    this.showToast();
                }
                else {
                    this.TellUser = res.Message;
                    this.showToast();
                    
                    //this.$router.push({ path: '/user/Login' })
                }
            })
        },
        open() {
            this.dialog = true
        },
        close() {
            this.dialog = false
        },
        showToast() {
            this.toast = true
            if (this.toastTimer) clearTimeout(this.toastTimer)
            this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
            if (this.TellUser == '未登录') {
                this.$http.post(api.LogOff()).then((res) => { });
                this.$store.dispatch('clearUser');
                this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1500)
            }
        },
        hideToast() {
            this.toast = false
            if (this.toastTimer) clearTimeout(this.toastTimer)
        },
        getCards() {
            this.$http.post(api.getMyBankCard()).then((res) => {
                if (res.Result) {
                    this.cards = res.Data;
                }
                else {
                    this.TellUser = res.Message;
                    this.showToast();
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// myBankCards.vue?abdda4a4